import axios from 'axios';
import { API_BASE_URL } from '../utils/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const handleSessionExpired = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
  sessionStorage.clear(); // just in case
  window.dispatchEvent(new CustomEvent('sessionExpired'));
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      handleSessionExpired();
    }
    return Promise.reject(error);
  }
);

export default api;
